import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';

/**
 * Unauthorized Page Component
 * Displayed when user doesn't have permission to access a route
 */
const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="text-center p-5">
        <div className="mb-4">
          <Icon
            icon="mdi:shield-lock-outline"
            className="text-danger"
            style={{ fontSize: '120px' }}
          />
        </div>
        <h1 className="display-4 fw-bold text-dark mb-3">403</h1>
        <h2 className="h4 text-secondary mb-4">Access Denied</h2>
        <p className="text-muted mb-4 mx-auto" style={{ maxWidth: '400px' }}>
          You don't have permission to access this page. Please contact your
          administrator if you believe this is an error.
        </p>
        <div className="d-flex gap-3 justify-content-center">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-outline-primary d-flex align-items-center gap-2"
          >
            <Icon icon="mdi:arrow-left" />
            Go Back
          </button>
          <Link
            to="/dashboard/overview"
            className="btn btn-primary d-flex align-items-center gap-2"
          >
            <Icon icon="mdi:home" />
            Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;